import type {RgbToBwSockets} from "#material/nodes/converter/rgb-to-bw/definition"
import type {MaterialNodeInputs, MaterialNodeParameters} from "#material/sockets/parameters"
import type {Version} from "@cm/graph-v3"

type Current = MaterialNodeParameters<RgbToBwSockets>
type Previous = Omit<Current, "inputs"> & {inputs: MaterialNodeInputs<RgbToBwSockets> & {image?: MaterialNodeInputs<RgbToBwSockets>["color"]}}

/** The node reads only color, so dropping an image link where color is linked too changes nothing it renders. */
export const linkImageAsColor: Version<Previous, Current> = {
    toNextVersion: ({inputs: {image, ...inputs}, ...parameters}) => ({
        ...parameters,
        inputs: image === undefined || inputs.color !== undefined ? inputs : {...inputs, color: image},
    }),
}
